import React from 'react';
import { CheckCircle, Settings, MessageSquare, Rocket } from 'lucide-react';
import { mockData } from './mockData';

const HowItWorks = () => {
  const { howItWorks } = mockData;

  const getStepIcon = (step) => {
    switch (step) {
      case 1:
        return <CheckCircle size={24} className="text-blue-600" />;
      case 2:
        return <Settings size={24} className="text-orange-600" />;
      case 3:
        return <MessageSquare size={24} className="text-green-600" />;
      case 4:
        return <Rocket size={24} className="text-purple-600" />;
      default:
        return <CheckCircle size={24} />;
    }
  };

  return (
    <section id="how-it-works" className="section section-bg">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="heading-1 mb-4">How It Works</h2>
          <p className="body-large max-w-2xl mx-auto">
            Our proven 4-step process gets your AI agents up and running quickly, 
            transforming how you handle customer interactions and business operations.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid gap-8 md:gap-12">
            {howItWorks.map((step, index) => (
              <div key={step.step} className="flex flex-col md:flex-row items-start gap-6">
                {/* Step Number & Icon */}
                <div className="flex-shrink-0 flex items-center justify-center w-16 h-16 rounded-full bg-white shadow-sm">
                  {getStepIcon(step.step)}
                </div>
                
                {/* Step Content */}
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="caption bg-gray-100 px-3 py-1 rounded-full">
                      STEP {step.step}
                    </span>
                  </div>
                  <h3 className="heading-2 mb-2">{step.title}</h3>
                  <p className="body-medium text-gray-600">{step.description}</p>
                </div>
                
                {/* Connection Line */}
                {index < howItWorks.length - 1 && (
                  <div className="hidden md:block absolute left-8 mt-20 w-0.5 h-12 bg-gray-200 transform translate-y-full"></div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center mt-16">
          <h3 className="heading-2 mb-4">Ready to Get Started?</h3>
          <p className="body-medium mb-6 max-w-xl mx-auto">
            Join hundreds of local businesses already using AI to automate their operations 
            and improve customer experience.
          </p>
          <button 
            onClick={() => document.querySelector('#contact').scrollIntoView({ behavior: 'smooth' })}
            className="btn-primary hover-scale"
          >
            Start Your Automation Journey
          </button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;